import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import SecureMessagePortalPage from '../components/SecureMessagePortalPage';
import Button from '../components/ui/Button';
import { api } from '../lib/api';

export default function SecureMessageViewer() {
  const { token } = useParams();
  const [dob, setDob] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const data = await api.verifySecureMessage({ token, dob });

      if (!data.success) {
        throw new Error(data.error || 'Unable to verify message');
      }

      setMessage(data.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-soft flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-2xl sm:max-w-3xl bg-white rounded-lg shadow-md p-6 space-y-6">
        <div className="text-center">
        </div>

        {message ? (
          <SecureMessagePortalPage
            clinicName="Recoverly"
            clinicSubtitle="Secure Message Portal"
            senderName="Your Care Team"
            messageSentTimestamp={message.created_at ? new Date(message.created_at).toLocaleString() : ''}
            messageBody={message.content}
            clinicPhoneNumber="(555) 123-4567"
            linkExpiryDate={message.created_at ? new Date(new Date(message.created_at).getTime() + 7 * 24 * 60 * 60 * 1000).toLocaleDateString() : ''}
            poweredByText="Powered by Recoverly"
          />
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-sm text-center text-gray-text">
              Please confirm your identity to view a secure message from your care team.
            </p>

            {error && (
              <div className="bg-danger/10 border border-danger text-danger p-2 rounded text-sm text-center" role="alert" aria-live="assertive">
                {error}
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-text mb-1">Date of Birth</label>
              <input
                type="text"
                placeholder="MM/DD/YYYY"
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-brand"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
                required
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              variant="primary"
              size="md"
              className="w-full py-2"
            >
              {loading ? 'Verifying...' : 'View Secure Message'}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
